import { AssetManager, TextureAtlas } from '@esotericsoftware/spine-threejs';
import { FileLoader, Loader, LoadingManager } from 'three';
import { debug } from '../config';

const arrayBufferToString = (buf: ArrayBuffer) => {
  return String.fromCharCode.apply(null, Array.from(new Uint16Array(buf)));
}
const getResponse = (raw: string | ArrayBuffer) => {
  return typeof raw === 'string' ? raw : arrayBufferToString(raw)
}
class JsonLoader extends FileLoader {
  load(url: string, onLoad: any, onProgress: any, onError: any) {
    let response = ''
    super.load(url, function (raw) {
      response = JSON.parse(getResponse(raw))
      if (onLoad) {
        onLoad(response);
      }
    }, onProgress, onError);
    return response;
  }
}

class AtlasLoader extends FileLoader {

  assetManager: AssetManager

  constructor(manager: LoadingManager) {
    super(manager)
    const base = manager.resolveURL('')
    this.assetManager = new AssetManager(base)
  }

  load(url: string, onLoad: any, onProgress: any, onError: any) {
    this.manager.itemStart(url)
    let response: TextureAtlas | null = null
    if(onProgress) {
      onProgress()
    }
    this.assetManager.loadTextureAtlas(url, (_, result) => {
      response = result
      if (onLoad) {
        onLoad(response);
      }
      this.manager.itemEnd(url)
    }, err => {
      if(onError) {
        onError(err)
      }
      this.manager.itemError(url)
    })
    return response
  }

}

export default class SpineLoader extends Loader {

  constructor(basePath: string) {
    super()
    this.manager.setURLModifier(url => `${basePath}/${url}`)
    this.manager.addHandler(/\.json$/, new JsonLoader(this.manager))
    this.manager.addHandler(/\.atlas$/, new AtlasLoader(this.manager))
  }

  load(url: string, onLoad: any, onProgress: any, onError: any) {
    const handler = this.manager.getHandler(url) as FileLoader
    if(debug) {
      console.log(`Loading "${url}" with ${handler.constructor.name}`)
    }
    return handler?.load(url, onLoad, onProgress, onError)
  }

}